import React from 'react';
import { useNavigate } from 'react-router-dom';
import CalendarButton from 'modules/home/pages/homePage/CalendarButton';
import { useAuth } from 'modules/auth/context/AuthContextV2';
import EmojiAvatar from 'modules/home/pages/homePage/EmojiAvatar';
import HomeIcon from './icons/HomeIcon';

const NavBottomMenu: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="fixed bottom-0 w-full max-w-md bg-[#0A0118] flex justify-between items-center px-12 py-4">
      <button
        onClick={() => navigate('/home')}
        className="flex items-center justify-center"
      >
        <HomeIcon />
      </button>

      <CalendarButton iconClassName="w-10 h-10" />

      <button
        onClick={() => navigate('/profile')}
        className="flex items-center justify-center"
      >
        <EmojiAvatar
          fullName={user.name}
          image={user.photoURL}
          size="small"
          className="w-8 h-8"
        />
      </button>
    </div>
  );
};

export default NavBottomMenu;
